/**
 * SUNDAY FLOOR — footer.js
 * The <details> elements in the footer default to `open` in markup, which is
 * the correct no-JS fallback (everything visible rather than everything
 * hidden if scripts fail). This script then collapses them on mobile and
 * keeps them open and non-collapsible on desktop.
 *
 * Native <details> content visibility can't be forced with author CSS alone
 * — the closed state is applied via a user-agent !important rule that
 * out-ranks author !important in the cascade — so a small, deliberate script
 * is the correct tool here rather than a CSS-only hack.
 *
 * On desktop the columns must be static, not just visually inert: CSS
 * `pointer-events: none` stops mouse/touch toggling but does nothing for
 * the keyboard, since <summary> is natively focusable and Enter/Space
 * activates it regardless of pointer-events. Removing it from the tab
 * order (tabindex="-1") is what actually prevents keyboard toggling, and
 * is restored on mobile so the disclosure control works normally there.
 */

const desktopQuery = window.matchMedia('(min-width: 990px)');

function syncFooterAccordions(event) {
  const isDesktop = event ? event.matches : desktopQuery.matches;
  document.querySelectorAll('.sf-footer__accordion').forEach((details) => {
    details.open = isDesktop;
    const summary = details.querySelector('summary');
    if (!summary) return;
    if (isDesktop) {
      summary.setAttribute('tabindex', '-1');
    } else {
      summary.removeAttribute('tabindex');
    }
  });
}

syncFooterAccordions();
desktopQuery.addEventListener('change', syncFooterAccordions);
